<template>
  <div class="container-fluid bg-white rounded-3">
    <div class="row">
      <div class="col-md-12 text-center p-4">
        <img src="@/assets/images/Frame.png" alt="" />
      </div>
      <div class="col-md-6 m-auto">
        <div class="row mb-5">
          <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
            <div class="col-md-12">
              <b-form-group
                label="Current Password"
                label-for="current-password"
              >
                <template v-slot:label>
                  {{ $t("Current Password") }}
                </template>
                <b-form-input
                  id="current-password"
                  type="password"
                  v-model="form.oldPassword"
                >
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12 m-auto">
              <b-form-group label="New Password" label-for="new-password">
                <template v-slot:label>
                    {{ $t("New Password") }}
                  </template>
                <b-form-input
                  id="current-password"
                  type="password"
                  v-model="form.newPassword"
                >
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12">
              <b-form-group
                label="Confirm Password"
                label-for="confirm-password"
              >
              <template v-slot:label>
                    {{ $t("Confirm Password") }}
                  </template>
                <b-form-input
                  id="current-password"
                  type="password"
                  v-model="form.confirmPassword"
                >
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-12 text-center d-flex justify-content-between">
              <button type="submit" class="btn btn-success p-3">Submit</button>
              <button type="reset" class="btn btn-success p-3">Reset</button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";

export default {
  name: "passwordChange",
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {},
  methods: {
    onSubmit() {
      apiRepository.changePass(this.form).then((res) => {
        if (res) {
          toast.success(res.data);
        }
      });
    },
    onReset() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
  },
};
</script>

<style>
.model-icon {
  font-size: 80px;
  color: #f5a623;
  background: #077747;
  padding: 30px;
  border-radius: 100px;
}
</style>
